// extracted by mini-css-extract-plugin
export default {"container":"FileDropArea_container__JA6oa"};